<template>
  <div>
    <div class="banner"></div>
    <leftSideBar :anchor="anchor"></leftSideBar>
    <SideBar></SideBar>
    <div class="page-box">
      <div class="secure-block"
           id="cancer">
        <div v-for="(disease,index) in diseases"
             :key="disease.id">
          <h4 class="dis-title rescue-title"
              v-if="disease.disease.length > 0">{{disease.name}}</h4>
          <ul class="dis-list"
              @click="toDisease($event)">
            <li :class="{'active':dis.id==diseaseId}"
                v-for="(dis,ind) in disease.disease"
                :data-id="dis.id"
                :key="dis.id">{{dis.name}}</li>
          </ul>
        </div>

      </div>
      <div class="secure-block"
           id="content">
        <div class="content">
          <h5 class="secure-title title01"
              style="padding-left: 0px;">{{diseaseName}}</h5>
          <div v-html=diseaseHtml></div>
        </div>

      </div>
      <div class="main">

        <h5 class="secure-title title01"
            id="hospital">合作医院
          <router-link to="/hospitalList/jbzt/0"
                       class="ccc"
                       target="_blank">更多&gt;</router-link>
        </h5>
        <div class="secure-hospital" style="position: relative;z-index: 101;">
          <router-link v-for="(hos,index) in hospitals"
                       target="_blank"
                       :to="'/hospitalInfo/' + hos.id">
            <img class="hospital-img"
                 :src="baseURL + hos.hospital_img"
                 alt="">
            <h6 class="hospital-name"
                v-html="setDoctorName(hos.name)"></h6>
            <p class="hospital-info">{{hos.easy_brief}}</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reason1 from "@/assets/images/medicine/reason1.png"
import reason2 from "@/assets/images/medicine/reason2.png"
import reason3 from "@/assets/images/medicine/reason3.png"
import map from "@/assets/images/home/icon-link1.png"
import leftSideBar from "@/components/LeftSideTitleBar.vue"
import SideBar from "@/components/SideBar"
import * as apis from '@/api/other'
import * as hospital from '@/api/hospital'
import { baseURL } from "@/api/axios"
export default {
  data () {
    return {
      baseURL,
      reason1,
      reason2,
      reason3,
      map,
      countries: [],
      cases: [],
      hospitals: [],
      diseases: [],
      diseaseName: '',
      diseaseHtml: '',
      diseaseId: 0,
      anchor: [
        { title: '疾病种类', id: 'cancer' },
        { title: '疾病介绍', id: 'content' },
        { title: '合作医院', id: 'hospital' },
      ]
    }
  },
  components: {
    leftSideBar,
    SideBar
  },
  mounted () {
    this.getHospitalList();
    this.getAllList();
    // this.getDiseaseDetail(159);
  },
  methods: {
    toDisease (e) {
      console.log(e)
      let id;
      if (e.target.localName === 'li') {
        id = e.target.dataset.id;
        this.diseaseId = id
        this.getDiseaseDetail(id);
      }
    },
    async getAllList () {
      try {
        let res = await apis.diseaseList({});
        if (res.code == 200) {
          this.diseases = res.data;
          for (let i = 0; i < this.diseases.length; i++) {
            if (this.diseases[i].disease.length) {
              this.diseaseId = this.diseases[i].disease[0].id
              break
            }
          }
          this.getDiseaseDetail(this.diseaseId)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getDiseaseDetail (id) {
      try {
        let data = {
          id
        }
        let res = await apis.diseaseDetail(data);
        if (res.code == 200) {
          this.diseaseName = res.data.name;
          this.diseaseHtml = res.data.details;
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getHospitalList () {
      try {
        let data = {
          hospital_type_id: 5,
          //疾病专题 5
          state_id: undefined,
          area_id: undefined,
          department_id: undefined,
          disease_id: [],
          keyword: undefined,
          page: 1
        }
        let res = await hospital.getAllHospitalList(data);
        if (res.code == 200) {
          // console.log(res.data.data)
          let rs = res.data.data.map(item => {
            return {
              ...item,
              info: this.getSimpleText(item.easy_brief)
            }
          });
          if (rs.length > 6) {
            this.hospitals = rs.slice(0, 6);
          } else {
            this.hospitals = rs;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .ccc:hover {
    color: #2d8cf0!important;
  }
.banner {
  position: relative;
  z-index: 10;
  height: 250px;
  background: url('../assets/images/medicine/banner-dis.jpg') no-repeat center;
}
.bg-white {
  background: #fff;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}
.secure-block {
  width: 980px;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 20px;
  margin: 20px auto 50px;
  .content {
    overflow: hidden;
  }
}
.secure-title {
  font-size: 24px;
  color: #000;
  line-height: 28px;
  padding-left: 40px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 28px auto;
  margin-bottom: 45px;
  a {
    float: right;
    color: #333130;
  }
}
.title01 {
  // background-image: url('../assets/images/home/icon-service3.png');
  background: url('../assets/images/home/hzyy-icon.png') no-repeat 0 107px;
  background-size: 28px 28px;
}
.title02 {
  background-image: url('../assets/images/home/icon-service3.png');
}
.secure-reason {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}
.secure-note {
  font-size: 16px;
  color: #000;
  line-height: 32px;
}
.secure-specials {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 72px;
  p {
    width: 234px;
    height: 65px;
    background: #ae1e10;
    color: #fff;
    font-size: 24px;
    line-height: 65px;
    text-align: center;
  }
}
.secure-hospital {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 32px;
  a {
    display: block;
    width: 302px;
    min-height: 396px;
    background: #fff;
    border: 1px solid #dcdcdc;
    margin-bottom: 32px;
    margin-right: 37px;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
  .hospital-img {
    width: 300px;
    height: 220px;
    margin-bottom: 25px;
  }
  .hospital-name {
    min-height: 47px;
    font-size: 18px;
    color: #333130;
    line-height: 24px;
    margin-bottom: 15px;
    padding: 0 10px;
  }
  .hospital-info {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    color: #9b9898;
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px;
  }
}
.user-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .secure-user {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 110px;
    border: 1px solid #dcdcdc;
    background: #fff;
    img {
      width: 60px;
      height: 60px;
      margin-right: 18px;
    }
    p {
      font-size: 28px;
      color: #ae1e10;
    }
  }
}
.medicine-case {
  width: 100%;
  background: #fff;
  border: 1px solid #ececec;
  padding: 34px 54px 34px 27px;
  margin-bottom: 10px;
  .case-img {
    width: 237px;
    height: 177px;
    margin-right: 34px;
  }
  .case-info {
    display: block;
    // width: 610px;
    // vertical-align: top;
    h5 {
      font-size: 20px;
      color: #373737;
      font-weight: normal;
      line-height: 26px;
      margin-bottom: 10px;
      p {
        display: inline-block;
        font-size: 16px;
      }
    }
    .case-ill {
      font-size: 18px;
      color: #cf1300;
      line-height: 22px;
      // background: url("../assets/images/medicine/line.jpg") repeat-x bottom;
      // padding-bottom: 16px;
      // margin-bottom: 18px;
    }
    .case-topic {
      font-size: 14px;
      color: #585858;
      line-height: 30px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.dis-title {
  font-size: 24px;
  color: #ae1e10;
  line-height: 64px;
}
.dis-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 108px;
    height: 72px;
    border: 1px solid #dcdcdc;
    background: #fff;
    font-size: 14px;
    color: #656565;
    text-align: center;
    margin-right: 8px;
    margin-bottom: 8px;
    cursor: pointer;
    border-radius: 4px;
  }
  li.active {
    color: #fff;
    background: #ae1e10;
  }
}
</style>
